import {styled} from "@mui/material/styles";

const getBorderColor = (theme, changed, warning, error) => {
    if (error) {
        return `${theme.palette.error.dark}`;
    } else if (warning) {
        return `${theme.palette.warning.dark}`;
    } else if (changed) {
        return `${theme.palette.info.dark}`;
    } else {
        return `${theme.palette.divider}`;
    }
}

const getBackgroundColor = (theme, changed, warning, error) => {
    if (error) {
        return theme.functions.rgba(theme.palette.error.main, 0.3);
    } else if (warning) {
        return theme.functions.rgba(theme.palette.warning.main, 0.3);
    } else if (changed) {
        return "white";
    } else {
        return "white";
    }
}


export const StyledInput = styled('input')(({theme, changed, warning=false, error=false}) => ({
    boxSizing: "border-box",
    width: "1.8rem",
    maxWidth: "1.8rem",
    height: "1.6rem",
    color: theme.palette.text.secondary,
    textAlign: "center",
    fontSize: "14px",
    fontFamily: theme.typography.fontFamily,

    border: "1px solid",
    borderColor: `${getBorderColor(theme, changed, warning, error)}`,
    borderRadius: "4px",
    backgroundColor: `${getBackgroundColor(theme, changed, warning, error)}`,

    '&:focus': {
        outline: "none !important",
        borderWidth: "2px"
    },

    // remove arrows
    "::-webkit-inner-spin-button, -webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0
    },
    MozAppearance: "textfield"
}));

export const DropdownButton = styled('button')(({theme, changed, warning=false, error=false, width}) => ({
    boxSizing: "border-box",
    width: width ?? "1.8rem",
    maxWidth: width ?? "1.8rem",
    height: "1.6rem",
    color: theme.palette.text.secondary,
    textAlign: "center",
    fontSize: "14px",
    fontFamily: theme.typography.fontFamily,
    marginLeft: "auto",
    marginRight: "auto",

    border: "1px solid",
    borderColor: `${getBorderColor(theme, changed, warning, error)}`,
    borderRadius: "4px",
    backgroundColor: `${getBackgroundColor(theme, changed, warning, error)}`,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    overflow: "hidden",

    '&:focus': {
        outline: "none !important",
        borderWidth: "2px"
    },

    '&[aria-expanded="true"]': {
        borderWidth: "2px"
    }
}));


export const WarningBox = styled('div')(({theme, severity}) => ({
    color: severity === "error" ? theme.palette.error.dark : theme.palette.warning.dark,
    border: `1px solid ${severity === "error" ? theme.palette.error.dark : theme.palette.warning.dark}`,
    borderRadius: "4px",
    backgroundColor: theme.functions.rgba(severity === "error" ? theme.palette.error.main : theme.palette.warning.main, 0.3),
    lineHeight: "1.6rem",
    height: "1.6rem",
}));